import React from 'react'
import {colors} from '../../utils/styles'
import {merge} from "../../utils/util"
import ReactTooltip from 'react-tooltip'

const secondItemStyle = {
  color: colors.grayMiddle,
  fontSize: 12,
  fontWeight: 400
}

export class Pair extends React.Component {
  constructor(props) {
    super(props)
    const stateValue = props.value || props
    this.state = {
      first: stateValue.first,
      second: stateValue.second,
      tipText: stateValue.tipText,
      icon: stateValue.icon,
      delayed: stateValue.delayed,
      firstStyle: stateValue.firstStyle
    }
    this.firstRef = React.createRef()
  }

  handleHover() {
    ReactTooltip.rebuild()
    ReactTooltip.show(this.firstRef.current)
  }

  handleHoverOut() {
    ReactTooltip.hide(this.firstRef.current)
  }

  getFirst(newStyle) {
    const state = this.state
    if (!state.icon) {
      if (!state.tipText) {
        return (<div style={newStyle}>{state.first || '\u00A0'}</div>)
      } else {
        return (<div data-tip={state.tipText} data-for="n2c3-tooltip" style={newStyle} ref={this.firstRef}
                     onMouseOver={this.handleHover.bind(this)}
                     onMouseOut={this.handleHoverOut.bind(this)}>{state.first || '\u00A0'}</div>)
      }
    }

    return (<div style={newStyle}>{state.icon}&nbsp;{state.first}</div>)
  }

  render() {
    let newStyle = this.state.delayed ? {color: colors.red} : {}
    if (this.state.firstStyle) {
      newStyle = merge(newStyle, this.state.firstStyle)
    }

    return (
        <div>
          {this.getFirst(newStyle)}
          <div style={secondItemStyle}>{this.state.second}</div>
        </div>
    )
  }
}

export default Pair